export const DEFAULT_IS_REFILL_ENABLED = false;
